import {priority} from '@priority-software/priority-proto-api/lib';
import {Actions} from '../../../features/Form/types';

export const prepareActionsMap = (
    rawActions: Actions,
    actionsDesign: priority.netitems.form.IMenuDesign[]
): Actions => {
    if (!actionsDesign || actionsDesign.length === 0) return rawActions;

    // Create lookup map for raw actions by Ename
    const rawActionsMap = new Map<string, priority.netitems.form.IAction>();
    rawActions.forEach(action => {
        rawActionsMap.set(action.Ename, action);
    });

    // Process actions based on design order
    const processedActions: Actions = [];

    actionsDesign.forEach(designAction => {
        if (designAction.Hidden === priority.netitems.form.Hide.HiddenByDesign) {
            return;
        }

        const rawAction = rawActionsMap.get(designAction.Name);
        if (!rawAction) return;

        processedActions.push(rawAction);
    });

    return processedActions;
};
